import { render, staticRenderFns } from "./CountersView.vue?vue&type=template&id=c4808ae0&scoped=true&"
import script from "./CountersView.vue?vue&type=script&lang=js&"
export * from "./CountersView.vue?vue&type=script&lang=js&"
import style0 from "./CountersView.vue?vue&type=style&index=0&id=c4808ae0&scoped=true&lang=css&"
import style1 from "./CountersView.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4808ae0",
  null
  
)

export default component.exports